import API from '@/api/log'

function defaultState() {
  return {
    userAnalysis: {},
    deviceAccessCounts: {},
    deviceLogs: {},
    eventLogs: {}
  }
}
const state = defaultState();

const actions = {

  // 解析結果を取得
  getUserAnalysis ({commit}, date) {
    return API.getUserAnalysis(date)
      .then(function(response) {
        var userAnalysis = response;
        commit('setUserAnalysis', userAnalysis)
      })
  },

  // デバイス毎のユーザー利用数を取得
  getDeviceAccessCounts ({commit}, payload) {
    let deviceId = payload.deviceId
    let from = payload.from
    let to = payload.to
    return API.getDeviceAccessCounts(deviceId, from, to)
      .then(function(response) {
        var deviceAccessCounts = response;
        commit('setDeviceAccessCounts', deviceAccessCounts)
      })
  },

  // デバイスに紐づくログを取得
  getDeviceLogs ({commit}, date) {
    return API.getDeviceLogs(date)
      .then(function(response) {
        var deviceLogs = response;
        commit('setDeviceLogs', deviceLogs)
      })
  },

  // イベントに紐づくログを取得
  getEventLogs ({commit}, date) {
    return API.getEventLogs(date)
      .then(function(response) {
        var eventLogs = response;
        commit('setEventLogs', eventLogs)
      })
  },
  signOutReset({commit}) {
    commit('_reset');
  }

}

const mutations = {

  // 解析結果をセット
  setUserAnalysis (state, userAnalysis) {
    state.userAnalysis = userAnalysis
  },

  // デバイス毎のユーザー利用数を取得
  setDeviceAccessCounts (state, deviceAccessCounts) {
    state.deviceAccessCounts = deviceAccessCounts
  },

  // デバイスに紐づくログをセット
  setDeviceLogs (state, deviceLogs) {
    state.deviceLogs = deviceLogs
  },

  // イベントに紐づくログをセット
  setEventLogs (state, eventLogs) {
    state.eventLogs = eventLogs
  },
  _reset(state) {
    const initialState = defaultState();
    for (const key in state) {
      if (state.hasOwnProperty(key)) {
        state[key] = initialState[key];
      }
    }
  }

}

const getters = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
